// extracted by mini-css-extract-plugin
export default {"container":"car-icon-mobile_container__iaQyH","img_container":"car-icon-mobile_img_container__XEeyY","back_item":"car-icon-mobile_back_item__nxWDM"};